import { Grid } from "@mui/material"

const VertcialCenterGridItem = ({ children }) => (
    <Grid item xs={12} md={6} sx={{ mt: 0, pt: 0, textAlign: "center", verticalAlign: "middle" }}>
        {children}
    </Grid>
)

export default VertcialCenterGridItem
